export default "__VITE_ASSET__CggCFFPc__"